import { render, staticRenderFns } from "./CanceledOrdersList.vue?vue&type=template&id=707d0328&scoped=true"
import script from "./CanceledOrdersList.vue?vue&type=script&lang=js"
export * from "./CanceledOrdersList.vue?vue&type=script&lang=js"
import style0 from "./CanceledOrdersList.vue?vue&type=style&index=0&id=707d0328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d0328",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fcomponents%2Freusable-components%2Fcanceled-orders-list%2FCanceledOrdersList.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports